import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  congratulations: {
    name: 'John',
    saleToday: '57.6',
  },
  subscribersGained: {
    series: [
      {
        name: 'Subscribers',
        data: [3, 33, 38, 52, 38, 60, 55],
      },
    ],
    analyticsData: {
      subscribers: null,
    },
  },
  ordersRecevied: {
    series: [
      {
        name: 'Orders',
        data: [10, 15, 8, 15, 7, 12, 8],
      },
    ],
    analyticsData: {
      orders: 38400,
    },
  },
  avgSessions: {
    sessions: 2700,
    lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
    growth: '+5.2%',
    goal: 100000,
    users: 100000,
    retention: 90,
    duration: 1,
    salesBar: {
      series: [
        {
          name: 'Sessions',
          data: [75, 125, 225, 175, 125, 75, 25],
        },
      ],
    },
  },
  supportTracker: {
    title: 'Support Tracker',
    lastDays: ['Last 28 Days', 'Last Month', 'Last Year'],
    totalTicket: 163,
    newTicket: 29,
    openTicket: 63,
    responseTime: 1,
    supportTrackerRadialBar: {
      series: [83],
    },
  },
  timeline: {
    step1: {
      title: '12 Invoices have been paid',
      subtitle: 'Invoices have been paid to the company.',
      img: require('@/assets/images/icons/json.png'),
      fileName: 'data.json',
      duration: '12 min ago',
    },
    step2: {
      title: 'Client Meeting',
      subtitle: 'Project meeting with john @10:15am',
      avatar: require('@/assets/images/portrait/small/avatar-s-9.jpg'),
      avatarName: 'John Doe (Client)',
      occupation: 'CEO of Infibeam',
      duration: '45 min ago',
    },
    step3: {
      title: 'Create a new project for client',
      subtitle: 'Add files to new design folder',
      duration: '2 day ago',
      avatars: [
        { userImg: require('@/assets/images/portrait/small/avatar-s-9.jpg'), name: 'Billy Hopkins' },
        { userImg: require('@/assets/images/portrait/small/avatar-s-6.jpg'), name: 'Amy Carson' },
        { userImg: require('@/assets/images/portrait/small/avatar-s-8.jpg'), name: 'Brandon Miles' },
        { userImg: require('@/assets/images/portrait/small/avatar-s-7.jpg'), name: 'Daisy Weber' },
        { userImg: require('@/assets/images/portrait/small/avatar-s-20.jpg'), name: 'Jenny Looper' },
      ],
    },
    step4: {
      title: 'Create a new project for client',
      duration: '5 day ago',
      subtitle: 'Add files to new design folder',
    },
  },
  salesChart: {
    series: [
      {
        name: 'Sales',
        data: [90, 50, 86, 40, 100, 20],
      },
      {
        name: 'Visit',
        data: [70, 75, 70, 76, 20, 85],
      },
    ],
  },
  appDesign: {
    date: '03 Sep, 20',
    title: 'App design',
    subtitle: 'You can Find Only Post and Quotes Related to IOS like ipad app design, iphone app design',
    teams: [
      { name: 'Figma', color: 'light-warning' },
      { name: 'Wireframe', color: 'light-primary' },
    ],
    members: [
      { img: require('@/assets/images/portrait/small/avatar-s-9.jpg'), color: 'primary' },
      { text: 'PI', color: 'light-danger' },
      { img: require('@/assets/images/portrait/small/avatar-s-14.jpg'), color: 'primary' },
      { img: require('@/assets/images/portrait/small/avatar-s-7.jpg'), color: 'primary' },
      { text: 'AL', color: 'light-secondary' },
    ],
    planing: [
      { title: 'Due Date', subtitle: '12 Apr, 21' },
      { title: 'Budget', subtitle: '$49251.91' },
      { title: 'Cost', subtitle: '$840.99' },
    ],
  },
  revenue: {
    years: ['2020', '2019', '2018'],
    price: '25,852',
    budget: '56,800',
    revenueReport: {
      series: [
        {
          name: 'Earning',
          data: [95, 177, 284, 256, 105, 63, 168, 218, 72],
        },
        {
          name: 'Expense',
          data: [-145, -80, -60, -180, -100, -60, -85, -75, -100],
        },
      ],
    },
    budgetChart: {
      series: [
        {
          data: [61, 48, 69, 52, 60, 40, 79, 60, 59, 43, 62],
        },
        {
          data: [20, 10, 30, 15, 23, 0, 25, 15, 20, 5, 27],
        },
      ],
    },
  },
  companyTable: [
    {
      avatarImg: require('@/assets/images/icons/toolbox.svg'),
      title: 'Boleto',
      avatarIcon: 'MonitorIcon',
      avatarColor: 'light-primary',
      avatarTitle: 'Technology',
      viewTitle: '23.4k',
      viewsub: 'in 24 hours',
      revenue: '891.2',
      sales: '68',
      loss: true,
    },
    {
      avatarImg: require('@/assets/images/icons/parachute.svg'),
      title: 'Motels',
      subtitle: 'vecav@hodzi.co.uk',
      avatarIcon: 'CoffeeIcon',
      avatarColor: 'light-success',
      avatarTitle: 'Grocery',
      viewTitle: '78k',
      viewsub: 'in 2 days',
      revenue: '668.51',
      sales: '97',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/brush.svg'),
      title: 'Zipcar',
      subtitle: 'davcilse@is.gov',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Fashion',
      viewTitle: '162',
      viewsub: 'in 5 days',
      revenue: '522.29',
      sales: '62',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/star.svg'),
      title: 'Owning',
      subtitle: 'us@cuhil.gov',
      avatarIcon: 'MonitorIcon',
      avatarColor: 'light-primary',
      avatarTitle: 'Technology',
      viewTitle: '214',
      viewsub: 'in 24 hours',
      revenue: '291.01',
      sales: '88',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/book.svg'),
      title: 'Cafés',
      subtitle: 'pudais@jife.com',
      avatarIcon: 'CoffeeIcon',
      avatarColor: 'light-success',
      avatarTitle: 'Grocery',
      viewTitle: '208',
      viewsub: 'in 1 week',
      revenue: '783.93',
      sales: '16',
      loss: true,
    },
    {
      avatarImg: require('@/assets/images/icons/rocket.svg'),
      title: 'Kmart',
      subtitle: 'bipri@cawiw.com',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Fashion',
      viewTitle: '990',
      viewsub: 'in 1 month',
      revenue: '780.05',
      sales: '78',
      loss: false,
    },
    {
      avatarImg: require('@/assets/images/icons/speaker.svg'),
      title: 'Payers',
      subtitle: 'luk@izug.io',
      avatarIcon: 'WatchIcon',
      avatarColor: 'light-warning',
      avatarTitle: 'Fashion',
      viewTitle: '12.9k',
      viewsub: 'in 12 hours',
      revenue: '531.49',
      sales: '42',
      loss: false,
    },
  ],
}
/* eslint-disable global-require */

// Mock data for RFM Analytics
const rfmData = {
  data: {
    segmentos: {
      Champions: { count: 150, percentage: 15.0 },
      'Loyal Customers': { count: 200, percentage: 20.0 },
      'Potential Loyalists': { count: 180, percentage: 18.0 },
      'New Customers': { count: 120, percentage: 12.0 },
      Promising: { count: 100, percentage: 10.0 },
      'Need Attention': { count: 80, percentage: 8.0 },
      'About to Sleep': { count: 70, percentage: 7.0 },
      'At Risk': { count: 60, percentage: 6.0 },
      'Cannot Lose Them': { count: 40, percentage: 4.0 },
    },
    clientes: [
      {
        id: 1,
        nome: 'João Silva',
        email: 'joao@email.com',
        recency: 5,
        frequency: 8,
        monetary: 1200.50,
        segmento: 'Champions',
      },
      {
        id: 2,
        nome: 'Maria Santos',
        email: 'maria@email.com',
        recency: 15,
        frequency: 6,
        monetary: 850.30,
        segmento: 'Loyal Customers',
      },
      {
        id: 3,
        nome: 'Pedro Costa',
        email: 'pedro@email.com',
        recency: 30,
        frequency: 4,
        monetary: 650.75,
        segmento: 'Potential Loyalists',
      },
    ],
    quartis: {
      recency: {
        q1: 10, q2: 30, q3: 60, q4: 120,
      },
      frequency: {
        q1: 2, q2: 4, q3: 7, q4: 15,
      },
      monetary: {
        q1: 100, q2: 300, q3: 800, q4: 2000,
      },
    },
  },
}

mock.onGet('/analytics/data').reply(() => [200, data])

// Mock data for Top Customers - estrutura real da API
const topCustomersData = {
  success: true,
  data: {
    period: {
      start: '2025-08-27',
      end: '2025-09-26',
      type: '30d',
    },
    top_customers: [
      {
        ranking: 1,
        cliente_store_id: 'C5046',
        nome: 'João Silva Santos', // Nome real do cliente
        email: 'joao.silva@email.com',
        telefone: '(11) 99999-1234',
        total_pedidos: 7,
        valor_total_gasto: 4890.65,
        ticket_medio: 698.66,
        ultimo_pedido: '2025-09-05T20:18:29.000Z',
        primeiro_pedido: '2025-05-13T20:18:29.000Z',
        dias_sem_comprar: 21,
        status: 'Ativo',
        score_combinado: 81.02,
        score_frequencia: 100,
        score_ticket_medio: 52.55,
        perfil: 'Premium',
      },
      {
        ranking: 2,
        cliente_store_id: 'C5034',
        nome: 'Maria Santos Costa', // Nome real do cliente
        email: 'maria.santos@email.com',
        telefone: '(11) 98888-5678',
        total_pedidos: 5,
        valor_total_gasto: 2748.54,
        ticket_medio: 549.71,
        ultimo_pedido: '2025-09-04T20:18:29.000Z',
        primeiro_pedido: '2025-05-19T20:18:29.000Z',
        dias_sem_comprar: 22,
        status: 'Ativo',
        score_combinado: 59.4,
        score_frequencia: 71.43,
        score_ticket_medio: 41.35,
        perfil: 'Frequente',
      },
      {
        ranking: 3,
        cliente_store_id: 'C5026',
        nome: 'Pedro Costa Lima', // Nome real do cliente
        email: 'pedro.costa@email.com',
        telefone: '(11) 97777-9012',
        total_pedidos: 4,
        valor_total_gasto: 2618.96,
        ticket_medio: 654.74,
        ultimo_pedido: '2025-07-27T20:18:29.000Z',
        primeiro_pedido: '2025-04-29T20:18:29.000Z',
        dias_sem_comprar: 61,
        status: 'Inativo',
        score_combinado: 53.98,
        score_frequencia: 57.14,
        score_ticket_medio: 49.25,
        perfil: 'Frequente',
      },
      {
        ranking: 4,
        cliente_store_id: 'C5044',
        nome: 'Ana Oliveira Silva', // Nome real do cliente
        email: 'ana.oliveira@email.com',
        telefone: '(11) 96666-3456',
        total_pedidos: 4,
        valor_total_gasto: 2258.94,
        ticket_medio: 564.74,
        ultimo_pedido: '2025-09-17T20:18:29.000Z',
        primeiro_pedido: '2025-05-18T20:18:29.000Z',
        dias_sem_comprar: 9,
        status: 'Ativo',
        score_combinado: 51.28,
        score_frequencia: 57.14,
        score_ticket_medio: 42.48,
        perfil: 'Frequente',
      },
      {
        ranking: 5,
        cliente_store_id: 'C5023',
        nome: 'Carlos Ferreira Souza', // Nome real do cliente
        email: 'carlos.ferreira@email.com',
        telefone: '(11) 95555-7890',
        total_pedidos: 1,
        valor_total_gasto: 1329.5,
        ticket_medio: 1329.5,
        ultimo_pedido: '2025-05-03T20:18:29.000Z',
        primeiro_pedido: '2025-05-03T20:18:29.000Z',
        dias_sem_comprar: 146,
        status: 'Perdido',
        score_combinado: 48.57,
        score_frequencia: 14.29,
        score_ticket_medio: 100,
        perfil: 'Ocasional',
      },
    ],
  },
  store: {
    uuid: 'b9bba0bb-c27f-453a-a78a-603f3d805c64',
    name: 'Monte Leste',
  },
}

// Mock RFM Analytics endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/rfm/).reply(() => [200, rfmData])

// Mock data for Best Selling Products - estrutura real da API
const bestSellingProductsData = {
  success: true,
  data: {
    period: {
      start: '2025-08-27',
      end: '2025-09-26',
      type: '30d',
    },
    produtos_mais_vendidos: [
      {
        ranking: 1,
        produto_id: 1005,
        produto_nome: 'Smartphone Galaxy S24',
        categoria: 'Eletrônicos',
        quantidade_vendida: 45,
        receita_total: 67500.00,
        ticket_medio: 1500.00,
        preco_unitario: 1500.00,
        pedidos_unicos: 38,
        clientes_unicos: 32,
      },
      {
        ranking: 2,
        produto_id: 1002,
        produto_nome: 'Notebook Dell Inspiron',
        categoria: 'Informática',
        quantidade_vendida: 28,
        receita_total: 84000.00,
        ticket_medio: 3000.00,
        preco_unitario: 3000.00,
        pedidos_unicos: 25,
        clientes_unicos: 22,
      },
      {
        ranking: 3,
        produto_id: 1008,
        produto_nome: 'Fone Bluetooth AirPods',
        categoria: 'Acessórios',
        quantidade_vendida: 67,
        receita_total: 40200.00,
        ticket_medio: 600.00,
        preco_unitario: 600.00,
        pedidos_unicos: 52,
        clientes_unicos: 45,
      },
      {
        ranking: 4,
        produto_id: 1012,
        produto_nome: 'Smart TV 55" Samsung',
        categoria: 'Eletrônicos',
        quantidade_vendida: 15,
        receita_total: 37500.00,
        ticket_medio: 2500.00,
        preco_unitario: 2500.00,
        pedidos_unicos: 14,
        clientes_unicos: 13,
      },
      {
        ranking: 5,
        produto_id: 1015,
        produto_nome: 'Tablet iPad Air',
        categoria: 'Eletrônicos',
        quantidade_vendida: 22,
        receita_total: 48400.00,
        ticket_medio: 2200.00,
        preco_unitario: 2200.00,
        pedidos_unicos: 20,
        clientes_unicos: 18,
      },
    ],
  },
  store: {
    uuid: 'b9bba0bb-c27f-453a-a78a-603f3d805c64',
    name: 'Monte Leste',
  },
}

// Mock RFM Analytics endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/rfm/).reply(() => [200, rfmData])

// Mock Top Customers endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/top-customers/).reply(() => [200, topCustomersData])

// Mock data for Demographics - estrutura real da API
const demographicsData = {
  success: true,
  data: {
    period: {
      start: '2025-08-27',
      end: '2025-09-26',
      type: '30d',
    },
    vendas_por_estado: [
      {
        estado: 'SP',
        total_pedidos: 156,
        valor_total: 89750.45,
        clientes_unicos: 89,
        ticket_medio: 575.32,
      },
      {
        estado: 'RJ',
        total_pedidos: 124,
        valor_total: 67890.30,
        clientes_unicos: 72,
        ticket_medio: 547.66,
      },
      {
        estado: 'MG',
        total_pedidos: 98,
        valor_total: 52340.80,
        clientes_unicos: 58,
        ticket_medio: 534.29,
      },
      {
        estado: 'GO',
        total_pedidos: 89,
        valor_total: 46475.09,
        clientes_unicos: 46,
        ticket_medio: 522.19,
      },
      {
        estado: 'PR',
        total_pedidos: 76,
        valor_total: 41230.60,
        clientes_unicos: 42,
        ticket_medio: 542.51,
      },
      {
        estado: 'SC',
        total_pedidos: 65,
        valor_total: 35890.25,
        clientes_unicos: 38,
        ticket_medio: 552.16,
      },
      {
        estado: 'RS',
        total_pedidos: 58,
        valor_total: 31450.80,
        clientes_unicos: 34,
        ticket_medio: 542.25,
      },
      {
        estado: 'BA',
        total_pedidos: 45,
        valor_total: 24680.90,
        clientes_unicos: 28,
        ticket_medio: 548.46,
      },
      {
        estado: 'PE',
        total_pedidos: 38,
        valor_total: 20150.40,
        clientes_unicos: 24,
        ticket_medio: 530.28,
      },
      {
        estado: 'CE',
        total_pedidos: 32,
        valor_total: 17890.60,
        clientes_unicos: 21,
        ticket_medio: 559.08,
      },
    ],
  },
  store: {
    uuid: 'b9bba0bb-c27f-453a-a78a-603f3d805c64',
    name: 'Monte Leste',
  },
}

// Mock RFM Analytics endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/rfm/).reply(() => [200, rfmData])

// Mock Top Customers endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/top-customers/).reply(() => [200, topCustomersData])

// Mock Best Selling Products endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/products/).reply(() => [200, bestSellingProductsData])

// Mock data for Campaigns Analytics - nova estrutura da API
const campaignsAnalyticsData = {
  success: true,
  data: [
    {
      campanha: {
        id: 1,
        name: 'Black Friday 2024',
        attribution_window_hours: 168,
        attribution_model: 'last_touch',
      },
      estatisticas: {
        audiencia: {
          total_contatos: 850,
          execucoes: 2,
        },
        mensagens: {
          total: 850,
          enviadas: 845,
          entregues: 820,
          lidas: 650,
          taxa_entrega: 97.0,
          taxa_leitura: 79.27,
        },
        conversoes: {
          total: 45,
          valor_total: 18900.50,
          leads_unicos: 42,
          taxa_conversao: 5.29,
          ticket_medio: 420.01,
          roi: 18.90,
        },
      },
      execucoes_detalhadas: [
        {
          id: 1,
          scheduled_for: '2024-11-29T10:00:00.000Z',
          status: 'completed',
          total_audience_size: 425,
          mensagens_criadas: 425,
          taxa_entrega: 97.2,
        },
        {
          id: 2,
          scheduled_for: '2024-11-30T14:00:00.000Z',
          status: 'completed',
          total_audience_size: 425,
          mensagens_criadas: 420,
          taxa_entrega: 96.8,
        },
      ],
      conversoes_detalhadas: [
        {
          order_id: 'PED001',
          occurred_at: '2024-11-29T15:30:00.000Z',
          value_amount: 299.90,
          lead_nome: 'João Silva',
          attribution_model: 'last_touch',
        },
        {
          order_id: 'PED002',
          occurred_at: '2024-11-29T16:45:00.000Z',
          value_amount: 450.00,
          lead_nome: 'Maria Santos',
          attribution_model: 'last_touch',
        },
      ],
    },
    {
      campanha: {
        id: 2,
        name: 'Cyber Monday Especial',
        attribution_window_hours: 72,
        attribution_model: 'last_touch',
      },
      estatisticas: {
        audiencia: {
          total_contatos: 620,
          execucoes: 1,
        },
        mensagens: {
          total: 620,
          enviadas: 615,
          entregues: 590,
          lidas: 420,
          taxa_entrega: 95.93,
          taxa_leitura: 71.19,
        },
        conversoes: {
          total: 28,
          valor_total: 12450.80,
          leads_unicos: 26,
          taxa_conversao: 4.52,
          ticket_medio: 444.67,
          roi: 15.60,
        },
      },
      execucoes_detalhadas: [
        {
          id: 3,
          scheduled_for: '2024-12-02T09:00:00.000Z',
          status: 'completed',
          total_audience_size: 620,
          mensagens_criadas: 615,
          taxa_entrega: 95.93,
        },
      ],
      conversoes_detalhadas: [
        {
          order_id: 'PED003',
          occurred_at: '2024-12-02T11:20:00.000Z',
          value_amount: 380.50,
          lead_nome: 'Carlos Oliveira',
          attribution_model: 'last_touch',
        },
      ],
    },
    {
      campanha: {
        id: 3,
        name: 'Promoção Natal 2024',
        attribution_window_hours: 240,
        attribution_model: 'last_touch',
      },
      estatisticas: {
        audiencia: {
          total_contatos: 750,
          execucoes: 3,
        },
        mensagens: {
          total: 750,
          enviadas: 740,
          entregues: 720,
          lidas: 580,
          taxa_entrega: 97.30,
          taxa_leitura: 80.56,
        },
        conversoes: {
          total: 32,
          valor_total: 8950.25,
          leads_unicos: 30,
          taxa_conversao: 4.27,
          ticket_medio: 279.70,
          roi: 11.25,
        },
      },
      execucoes_detalhadas: [
        {
          id: 4,
          scheduled_for: '2024-12-15T08:00:00.000Z',
          status: 'completed',
          total_audience_size: 250,
          mensagens_criadas: 248,
          taxa_entrega: 97.6,
        },
        {
          id: 5,
          scheduled_for: '2024-12-20T10:00:00.000Z',
          status: 'completed',
          total_audience_size: 250,
          mensagens_criadas: 246,
          taxa_entrega: 97.2,
        },
        {
          id: 6,
          scheduled_for: '2024-12-23T12:00:00.000Z',
          status: 'completed',
          total_audience_size: 250,
          mensagens_criadas: 246,
          taxa_entrega: 97.0,
        },
      ],
      conversoes_detalhadas: [
        {
          order_id: 'PED004',
          occurred_at: '2024-12-15T14:30:00.000Z',
          value_amount: 199.90,
          lead_nome: 'Ana Costa',
          attribution_model: 'last_touch',
        },
      ],
    },
    {
      campanha: {
        id: 4,
        name: 'Volta às Aulas 2025',
        attribution_window_hours: 120,
        attribution_model: 'last_touch',
      },
      estatisticas: {
        audiencia: {
          total_contatos: 380,
          execucoes: 1,
        },
        mensagens: {
          total: 380,
          enviadas: 375,
          entregues: 360,
          lidas: 280,
          taxa_entrega: 96.0,
          taxa_leitura: 77.78,
        },
        conversoes: {
          total: 15,
          valor_total: 3890.20,
          leads_unicos: 14,
          taxa_conversao: 3.95,
          ticket_medio: 259.35,
          roi: 8.45,
        },
      },
      execucoes_detalhadas: [
        {
          id: 7,
          scheduled_for: '2025-01-15T07:00:00.000Z',
          status: 'completed',
          total_audience_size: 380,
          mensagens_criadas: 375,
          taxa_entrega: 96.0,
        },
      ],
      conversoes_detalhadas: [
        {
          order_id: 'PED005',
          occurred_at: '2025-01-15T16:20:00.000Z',
          value_amount: 320.80,
          lead_nome: 'Pedro Lima',
          attribution_model: 'last_touch',
        },
      ],
    },
    {
      campanha: {
        id: 5,
        name: 'Liquidação Verão',
        attribution_window_hours: 96,
        attribution_model: 'last_touch',
      },
      estatisticas: {
        audiencia: {
          total_contatos: 280,
          execucoes: 1,
        },
        mensagens: {
          total: 280,
          enviadas: 275,
          entregues: 270,
          lidas: 210,
          taxa_entrega: 98.18,
          taxa_leitura: 77.78,
        },
        conversoes: {
          total: 7,
          valor_total: 1700.00,
          leads_unicos: 7,
          taxa_conversao: 2.50,
          ticket_medio: 242.86,
          roi: 6.07,
        },
      },
      execucoes_detalhadas: [
        {
          id: 8,
          scheduled_for: '2025-02-01T11:00:00.000Z',
          status: 'completed',
          total_audience_size: 280,
          mensagens_criadas: 275,
          taxa_entrega: 98.18,
        },
      ],
      conversoes_detalhadas: [
        {
          order_id: 'PED006',
          occurred_at: '2025-02-01T18:45:00.000Z',
          value_amount: 180.50,
          lead_nome: 'Lucia Ferreira',
          attribution_model: 'last_touch',
        },
      ],
    },
  ],
  store: {
    uuid: 'b9bba0bb-c27f-453a-a78a-603f3d805c64',
    name: 'Monte Leste',
  },
}

// Mock Demographics endpoint
mock.onGet(/\/api\/stores\/[^/]+\/analytics\/demographics/).reply(() => [200, demographicsData])

// Mock Campaigns Analytics endpoint - estrutura real da API
const campaignsAnalyticsRealData = {
  success: true,
  data: {
    period: {
      all: true,
    },
    resumo_geral: {
      total_campanhas: 5,
      total_contatos: 2350,
      total_mensagens: 2320,
      total_conversoes: 127,
      valor_total_convertido: 38901.65,
      taxa_conversao_media: 5.47,
      roi_medio: 12.85,
    },
    campanhas: [
      {
        id: 1,
        name: 'Black Friday 2024',
        description: 'Campanha promocional Black Friday',
        attribution_window_hours: 168,
        attribution_model: 'last_touch',
        created_at: '2024-11-20T10:00:00.000Z',
        total_execucoes: 2,
        total_contatos_enviados: 500,
        total_mensagens_enfileiradas: 500,
        mensagens: {
          total: 500,
          enviadas: 495,
          entregues: 480,
          lidas: 320,
          falharam: 5,
          bloqueadas: 0,
          taxa_entrega: 96.0,
          taxa_leitura: 66.67,
        },
        conversoes: {
          total: 25,
          valor_total: 8900.50,
          ticket_medio: 356.02,
          leads_unicos: 23,
          taxa_conversao: 5.0,
        },
        roi: 17.80,
      },
      {
        id: 2,
        name: 'Cyber Monday 2024',
        description: 'Campanha Cyber Monday',
        attribution_window_hours: 168,
        attribution_model: 'last_touch',
        created_at: '2024-12-01T08:00:00.000Z',
        total_execucoes: 1,
        total_contatos_enviados: 750,
        total_mensagens_enfileiradas: 750,
        mensagens: {
          total: 750,
          enviadas: 740,
          entregues: 720,
          lidas: 450,
          falharam: 10,
          bloqueadas: 0,
          taxa_entrega: 97.33,
          taxa_leitura: 62.5,
        },
        conversoes: {
          total: 47,
          valor_total: 12500.75,
          ticket_medio: 265.96,
          leads_unicos: 45,
          taxa_conversao: 6.2,
        },
        roi: 16.87,
      },
      {
        id: 3,
        name: 'Natal 2024',
        description: 'Campanha de Natal',
        attribution_window_hours: 96,
        attribution_model: 'first_touch',
        created_at: '2024-12-15T12:00:00.000Z',
        total_execucoes: 3,
        total_contatos_enviados: 320,
        total_mensagens_enfileiradas: 320,
        mensagens: {
          total: 320,
          enviadas: 315,
          entregues: 310,
          lidas: 280,
          falharam: 5,
          bloqueadas: 0,
          taxa_entrega: 98.41,
          taxa_leitura: 90.32,
        },
        conversoes: {
          total: 15,
          valor_total: 5600.30,
          ticket_medio: 373.35,
          leads_unicos: 15,
          taxa_conversao: 4.8,
        },
        roi: 18.01,
      },
      {
        id: 4,
        name: 'Ano Novo 2025',
        description: 'Campanha de Ano Novo',
        attribution_window_hours: 72,
        attribution_model: 'last_touch',
        created_at: '2024-12-28T15:00:00.000Z',
        total_execucoes: 1,
        total_contatos_enviados: 420,
        total_mensagens_enfileiradas: 420,
        mensagens: {
          total: 420,
          enviadas: 410,
          entregues: 400,
          lidas: 350,
          falharam: 10,
          bloqueadas: 0,
          taxa_entrega: 97.56,
          taxa_leitura: 87.5,
        },
        conversoes: {
          total: 23,
          valor_total: 7800.90,
          ticket_medio: 339.17,
          leads_unicos: 22,
          taxa_conversao: 5.5,
        },
        roi: 18.57,
      },
      {
        id: 5,
        name: 'Liquidação Verão',
        description: 'Liquidação de Verão 2025',
        attribution_window_hours: 48,
        attribution_model: 'last_touch',
        created_at: '2025-01-15T09:00:00.000Z',
        total_execucoes: 1,
        total_contatos_enviados: 280,
        total_mensagens_enfileiradas: 280,
        mensagens: {
          total: 280,
          enviadas: 275,
          entregues: 270,
          lidas: 210,
          falharam: 5,
          bloqueadas: 0,
          taxa_entrega: 98.18,
          taxa_leitura: 77.78,
        },
        conversoes: {
          total: 9,
          valor_total: 4200.60,
          ticket_medio: 466.73,
          leads_unicos: 9,
          taxa_conversao: 3.2,
        },
        roi: 15.00,
      },
    ],
  },
  store: {
    uuid: 'b9bba0bb-c27f-453a-a78a-603f3d805c64',
    name: 'Monte Leste',
  },
}

// Mock Campaigns Analytics endpoint
mock.onGet(/\/api\/stores\/[^/]+\/campaigns\/analytics/).reply(() => [200, campaignsAnalyticsRealData])
